var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingStarter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 60 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6947 45.7743C18.8522 45.6883 18.0107 45.9483 17.3632 46.4946C16.716 47.0408 16.3179 47.8265 16.2607 48.6718C16.2607 48.6718 16.016 52.3287 16.1297 54.9227C16.1994 56.5146 17.4554 57.799 19.045 57.9043C19.045 57.9043 23.1116 58.173 26.725 58.1477C27.5641 58.1418 28.3657 57.7987 28.9491 57.1955C29.5325 56.5927 29.8488 55.7805 29.8272 54.9418C29.8272 54.9418 29.7316 52.0752 30.1135 50.3349C30.3044 49.4643 30.115 48.554 29.5925 47.8321C29.0697 47.1102 28.2641 46.6462 27.3775 46.5558L19.6947 45.7743Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.015 45.3402C30.326 45.3905 28.9829 46.7743 28.9829 48.464C28.9829 48.464 29.0157 54.1196 29.3188 55.6687C29.6057 57.1355 30.891 58.1937 32.3857 58.1937C32.3857 58.1937 36.8916 58.1933 41.2691 57.6783C42.85 57.4924 44.0385 56.1477 44.0288 54.5558C44.0288 54.5558 43.8832 48.6033 43.3422 47.1362C42.8775 45.8758 41.6597 45.0533 40.3172 45.0933L32.015 45.3402Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.7435 45.9496C25.1541 45.8512 23.7447 46.9637 23.4713 48.5324C23.4713 48.5324 22.5857 53.7105 22.686 56.8833C22.7122 57.7202 23.0735 58.5118 23.6888 59.0799C24.3038 59.6483 25.1213 59.9458 25.9579 59.9062C25.9579 59.9062 29.1325 59.7558 34.0304 59.7862C34.8985 59.7915 35.7294 59.4355 36.3244 58.8037C36.9197 58.1721 37.225 57.3212 37.1679 56.4552C37.1679 56.4552 36.6472 50.0015 35.9141 48.2593C35.4538 47.1646 34.4125 46.4258 33.2272 46.3521L26.7435 45.9496Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4582 8.03397C20.7119 8.22835 20.0641 8.69209 19.6391 9.33553C19.6391 9.33553 12.7775 19.7802 13.7385 31.2118C13.6754 32.4946 13.39 38.9158 13.7357 43.889C13.9269 46.6433 14.3988 49.0077 15.0204 50.2677C15.0347 50.3518 15.2685 51.4527 17.6219 52.4862C19.09 53.1308 22.3888 54.0843 29.7797 54.3696C30.3057 54.4058 34.356 54.5843 42.9857 52.3552C43.8563 52.1305 44.5879 51.5415 44.9935 50.739C44.9935 50.739 46.2829 48.533 46.8969 37.7262C46.9007 37.6602 46.9025 37.5943 46.9019 37.5283C46.9019 37.5283 46.6985 19.8418 40.5738 9.66522C40.1638 8.98428 39.51 8.48491 38.7454 8.26928L30.8279 6.03428C30.2932 5.88334 29.7279 5.87772 29.1904 6.01772L21.4582 8.03397Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1566 11.948C17.5397 13.4302 18.1466 15.139 19.5604 15.8999C20.9741 16.6612 22.7344 16.2271 23.6325 14.8962C24.16 14.1143 25.1157 13.7908 25.9957 13.5552C27.8629 13.0555 29.6925 13.1733 29.6925 13.1733C29.7679 13.1783 29.8435 13.1808 29.9188 13.1802C34.1182 13.1558 36.1663 14.6874 36.5235 15.0293C37.6779 16.1349 38.7641 15.9768 38.7641 15.9768C39.82 15.9768 40.8047 15.4433 41.3816 14.559C41.9585 13.6743 42.0497 12.5583 41.6238 11.5921C36.2207 -0.673529 29.9491 0.00678305 29.9491 0.00678305C29.9272 0.00709555 29.9057 0.00740838 29.8841 0.00834588C27.7016 0.0770959 25.5235 1.28272 23.676 3.18616C20.446 6.51397 18.1566 11.948 18.1566 11.948Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9144 26.9808C23.0288 25.8693 22.541 24.7815 21.635 24.1274C20.7291 23.4733 19.5432 23.3527 18.5241 23.8108C18.5241 23.8108 8.05879 28.6583 4.75442 32.773C4.73098 32.8027 4.70786 32.8324 4.68536 32.8627C4.68536 32.8627 1.84473 36.3877 2.19442 43.7983C2.24129 44.7949 2.76129 45.709 3.59379 46.2587C4.42629 46.8083 5.47129 46.9277 6.40629 46.5796C6.40629 46.5796 11.2566 44.8021 20.7744 43.6774C22.4338 43.4812 23.6454 42.0146 23.5244 40.3483C23.5244 40.3483 22.6854 29.2058 22.9144 26.9808Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.4097 23.953C40.3907 23.4946 39.2044 23.6152 38.2985 24.2693C37.3929 24.9233 36.905 26.0115 37.0194 27.1227C37.2482 29.3477 36.4091 40.4902 36.4091 40.4902C36.2885 42.1568 37.5 43.6233 39.1591 43.8193C48.6772 44.9443 53.5275 46.7218 53.5275 46.7218C54.4625 47.0699 55.5072 46.9505 56.3397 46.4008C57.1722 45.8512 57.6922 44.9368 57.7394 43.9402C58.0888 36.5299 55.2485 33.0049 55.2485 33.0049C55.226 32.9746 55.2029 32.9446 55.1791 32.9152C51.875 28.8005 41.4097 23.953 41.4097 23.953Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.1104 51.3402C16.1104 51.3402 10.2797 53.688 9.95942 60.948C9.87192 62.9296 11.4097 64.6093 13.3913 64.6968C15.3729 64.784 17.0525 63.2462 17.14 61.2649C17.2441 58.9015 18.8929 57.9765 18.9707 57.9343C20.7822 57.138 21.6113 55.0265 20.8241 53.2121C20.0344 51.3927 17.9163 50.5565 16.0966 51.3462L16.1104 51.3402Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.041 53.7949C15.041 53.7949 4.44348 52.3733 0.216606 64.0105C-0.460581 65.8749 0.503169 67.938 2.36723 68.6152C4.23161 69.2924 6.29504 68.3287 6.97223 66.4643C9.07317 60.6799 14.0363 60.9249 14.2285 60.9365C16.1997 61.154 17.975 59.7362 18.1975 57.7687C18.4207 55.7977 17.0013 54.0168 15.0307 53.7937L15.041 53.7949Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2532 62.5618C23.0604 61.8987 24.0322 59.9149 23.4288 58.0708C22.8147 56.1943 20.7991 55.1655 18.9213 55.7649C18.8785 55.7768 12.5129 57.5602 12.5129 65.7943C12.5129 67.7777 14.1232 69.388 16.1066 69.388C18.09 69.388 19.7004 67.7777 19.7004 65.7943C19.7004 63.5918 21.1666 62.6171 21.2532 62.5618Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8482 60.0299C22.8479 60.0324 22.8475 60.0349 22.8472 60.0374C22.8472 60.0374 22.4032 63.719 21.8797 64.824C21.0304 66.6165 21.7963 68.7612 23.5891 69.6102C25.3816 70.4593 27.526 69.6933 28.375 67.9008C29.1288 66.3102 29.9625 61.0533 29.9625 61.0533C29.9629 61.0512 29.9632 61.0487 29.9635 61.0465C30.2441 59.083 28.8775 57.2612 26.9141 56.9805C24.9507 56.6999 23.1288 58.0665 22.8482 60.0299Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.0304 60.7465C30.0307 60.7477 30.031 60.749 30.031 60.7502C30.031 60.7502 30.8779 65.8124 31.6832 67.7446C32.446 69.5755 34.5516 70.4427 36.3825 69.6799C38.2135 68.9171 39.0807 66.8112 38.3175 64.9802C37.7032 63.5052 37.1297 59.6233 37.1297 59.6233C37.1294 59.6221 37.1294 59.6208 37.1291 59.6196C36.8182 57.6608 34.9754 56.3227 33.0163 56.6337C31.0575 56.9446 29.7194 58.7874 30.0304 60.7465Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.8135 62.5193C38.9338 62.6271 40.1866 63.7999 40.5391 66.1208C40.8369 68.0818 42.6707 69.4321 44.6316 69.1343C46.5929 68.8365 47.9429 67.0024 47.645 65.0415C46.3563 56.5574 40.8607 55.6327 40.8279 55.6271C38.9272 55.159 36.9916 56.3074 36.495 58.2105C36.0166 60.0443 37.0469 61.9196 38.8135 62.5193Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.7322 57.9037C40.7322 57.9037 42.7713 58.9908 42.7713 61.3905C42.7713 63.374 44.3816 64.9843 46.365 64.9843C48.3485 64.9843 49.9588 63.374 49.9588 61.3905C49.9588 54.6227 44.1569 51.583 44.0394 51.5224C42.2785 50.6105 40.1082 51.2999 39.1963 53.0612C38.2841 54.8224 38.9735 56.993 40.7347 57.9049L40.7322 57.9037ZM43.6722 52.389L43.7135 52.4124L43.645 52.3743L43.6722 52.389Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.465 60.9774C45.4694 60.9774 50.2947 60.8212 52.8372 66.3771C53.6625 68.1808 55.7969 68.9749 57.6007 68.1496C59.4041 67.3243 60.1985 65.1899 59.3729 63.3862C54.5454 52.8368 44.9125 53.8112 44.9125 53.8112C42.9469 53.963 41.4654 55.6927 41.6182 57.6702C41.7707 59.644 43.4938 61.1233 45.4663 60.9774H45.465Z",
    fill: "var(--fill-0, white)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3785 48.883C19.3785 48.883 19.1444 52.3365 19.2516 54.7862C19.2516 54.7862 23.1972 55.0474 26.7032 55.0227C26.7032 55.0227 26.6166 51.6893 27.0613 49.6649L19.3785 48.883Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.1079 48.464C32.1079 48.464 32.1079 53.649 32.3857 55.0687C32.3857 55.0687 36.7066 55.0687 40.9038 54.5749C40.9038 54.5749 40.8732 49.4727 40.41 48.2171L32.1079 48.464Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.55 49.0687C26.55 49.0687 25.7166 53.8524 25.8094 56.7846C25.8094 56.7846 29.05 56.6302 34.0497 56.6612C34.0497 56.6612 33.6757 50.9971 33.0338 49.4712L26.55 49.0687Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2466 11.0577C22.2466 11.0577 15.8938 20.6758 16.8704 31.1524C16.8704 31.1524 16.0713 45.7133 17.8472 48.9321C17.8472 48.9321 18.7363 50.823 29.9588 51.249C29.9588 51.249 33.6241 51.5458 42.2044 49.3296C42.2044 49.3296 43.2222 47.3155 43.7769 37.549C43.7769 37.549 43.6672 20.8655 37.8963 11.2768L29.9788 9.04178L22.2466 11.0577Z",
    fill: "var(--fill-0, #FFBE32)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.0419 13.1483C21.0419 13.1483 25.146 3.28428 29.9829 3.13178C29.9829 3.13178 34.4607 3.08335 38.7641 12.8518C38.7641 12.8518 36.1557 10.019 29.9007 10.0552C29.9007 10.0552 23.4204 9.62272 21.0419 13.1483Z",
    fill: "var(--fill-0, #FF9227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9597 44.9437C17.0216 45.5596 22.8947 43.4155 26.1263 40.2515C26.5241 39.8618 26.3954 25.6649 25.7141 24.0543C25.6182 23.8274 18.9163 17.8621 18.6022 18.7702C17.3929 22.268 16.4488 26.6302 16.8704 31.1524C16.8704 31.1524 16.4129 39.4921 16.9597 44.9437Z",
    fill: "var(--fill-0, #FF9227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.1469 19.0671C40.9144 18.2674 34.461 23.3183 34.1197 24.078C33.1375 26.2646 33.316 35.8224 33.725 40.4662C33.8313 41.6708 42.9394 46.2893 43.1029 45.0908C43.3422 43.3337 43.5869 40.8968 43.7769 37.549C43.7769 37.549 43.7138 27.9046 41.1469 19.0671Z",
    fill: "var(--fill-0, #FF9227)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.9372 19.794C29.9372 19.794 36.0175 19.169 35.6197 25.7033C35.6197 25.7033 35.9607 31.2152 29.6532 31.1018C29.6532 31.1018 24.1413 31.5562 24.0844 25.5899C24.0844 25.5899 23.5732 19.8508 29.9372 19.794Z",
    fill: "var(--fill-0, #4BCBEC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8057 26.6608C19.8057 26.6608 10.2029 30.9796 7.19098 34.7299C7.19098 34.7299 5.03192 37.6277 5.31598 43.6512C5.31598 43.6512 10.4069 41.7558 20.4075 40.574C20.4075 40.574 19.5675 28.9765 19.8057 26.6608Z",
    fill: "var(--fill-0, #4BCBEC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3488 41.5043C14.3488 41.5043 14.27 39.4433 14.7785 37.8902C14.8319 37.7262 14.7425 37.5496 14.5785 37.4958C14.4147 37.4424 14.2379 37.5318 14.1844 37.6958C13.6454 39.3427 13.7244 41.5277 13.7244 41.5277C13.7307 41.6999 13.876 41.8346 14.0482 41.8283C14.2207 41.8218 14.3554 41.6768 14.3488 41.5043Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09504 42.6277C9.09504 42.6277 9.03754 40.9705 9.56411 39.8062C9.63536 39.649 9.56536 39.464 9.40817 39.3927C9.2513 39.3218 9.06598 39.3915 8.99473 39.5487C8.41598 40.828 8.47036 42.6477 8.47036 42.6477C8.47598 42.8202 8.62036 42.9555 8.79286 42.9499C8.96504 42.9446 9.10067 42.7999 9.09504 42.6277Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1279 26.803C40.1279 26.803 49.731 31.1215 52.7425 34.8718C52.7425 34.8718 54.9019 37.7699 54.6179 43.793C54.6179 43.793 49.5269 41.898 39.526 40.7162C39.526 40.7162 40.366 29.1187 40.1279 26.803Z",
    fill: "var(--fill-0, #4BCBEC)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3207 42.7343C51.3207 42.7343 51.2466 40.5683 50.9091 39.7005C50.8466 39.5399 50.6654 39.4602 50.5047 39.5227C50.3438 39.5852 50.2641 39.7665 50.3266 39.9271C50.641 40.7352 50.696 42.7537 50.696 42.7537C50.7013 42.9258 50.8457 43.0615 51.0182 43.0562C51.1904 43.0508 51.326 42.9068 51.3207 42.7343Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.2069 41.6677C46.2069 41.6677 46.2919 38.718 45.9091 37.6165C45.8522 37.4537 45.6741 37.3674 45.5113 37.424C45.3482 37.4805 45.2619 37.659 45.3188 37.8218C45.6804 38.8618 45.5822 41.6477 45.5822 41.6477C45.5766 41.8199 45.7122 41.9643 45.8844 41.9699C46.0569 41.9755 46.2013 41.8399 46.2069 41.6677Z",
    fill: "var(--fill-0, white)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3407 54.2127C17.3407 54.2127 13.3085 55.9399 13.0813 61.0858C13.07 61.3443 13.2707 61.5633 13.5291 61.5746C13.7875 61.5862 14.0066 61.3855 14.0179 61.1271C14.2172 56.613 17.7138 55.0727 17.7138 55.0727C17.9513 54.9699 18.0604 54.6933 17.9572 54.4562C17.8544 54.219 17.5782 54.1099 17.3407 54.2127Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6794 56.899C14.6794 56.899 6.47192 55.9424 3.15379 65.0774C3.06536 65.3205 3.19098 65.5896 3.43442 65.678C3.67754 65.7665 3.94661 65.6405 4.03504 65.3974C7.08098 57.0112 14.5741 57.8305 14.5741 57.8305C14.831 57.8596 15.0635 57.6746 15.0925 57.4174C15.1216 57.1602 14.9363 56.928 14.6794 56.899Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8675 58.743C19.8675 58.743 15.6379 60.0868 15.6379 65.7943C15.6379 66.053 15.8482 66.263 16.1066 66.263C16.3654 66.263 16.5754 66.053 16.5754 65.7943C16.5754 60.8474 20.1591 59.634 20.1591 59.634C20.405 59.5537 20.5394 59.2887 20.4588 59.0427C20.3785 58.7968 20.1135 58.6627 19.8675 58.743Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9419 60.4718C25.9419 60.4718 25.3282 64.844 24.7038 66.1618C24.5929 66.3955 24.6929 66.6755 24.9266 66.7862C25.1607 66.8968 25.4404 66.7971 25.551 66.563C26.2054 65.1821 26.87 60.6046 26.87 60.6046C26.9066 60.3483 26.7282 60.1108 26.4722 60.074C26.216 60.0374 25.9785 60.2158 25.9419 60.4718Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1169 60.2565C33.1169 60.2565 33.845 64.8083 34.5675 66.5427C34.6672 66.7815 34.9419 66.8946 35.1807 66.7952C35.4194 66.6958 35.5325 66.4212 35.4332 66.1821C34.7354 64.5074 34.0429 60.1096 34.0429 60.1096C34.0022 59.854 33.7619 59.6796 33.5063 59.7199C33.2507 59.7605 33.0763 60.0008 33.1169 60.2565Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8541 59.5712C39.8541 59.5712 42.8329 60.4124 43.6285 65.6515C43.6675 65.9074 43.9066 66.0833 44.1625 66.0446C44.4182 66.0058 44.5944 65.7665 44.5554 65.5108C43.6466 59.5268 40.0907 58.664 40.0907 58.664C39.8404 58.5987 39.5841 58.749 39.5188 58.9993C39.4535 59.2496 39.6038 59.5058 39.8541 59.5712Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.1719 55.1299C42.1719 55.1299 45.8963 57.063 45.8963 61.3905C45.8963 61.6493 46.1063 61.8593 46.365 61.8593C46.6238 61.8593 46.8338 61.6493 46.8338 61.3905C46.8338 56.4843 42.6029 54.2974 42.6029 54.2974C42.3732 54.1787 42.09 54.2687 41.971 54.4983C41.8522 54.728 41.9422 55.0112 42.1719 55.1299Z",
    fill: "var(--fill-0, #3C69C6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2375 57.8608C45.2375 57.8608 52.1457 57.3562 55.6788 65.0768C55.7866 65.3121 56.065 65.4155 56.3004 65.308C56.5354 65.2002 56.6391 64.9218 56.5313 64.6868C52.7004 56.3149 45.1654 56.9262 45.1654 56.9262C44.9072 56.9462 44.7141 57.1715 44.7341 57.4296C44.7538 57.6874 44.9794 57.8808 45.2375 57.8608Z",
    fill: "var(--fill-0, #3C69C6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingStarter);
export default __webpack_public_path__ + "static/media/pricing-starter.e3d9b591e0d61c5a946658e9cc8d450c.svg";
export { ForwardRef as ReactComponent };